import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Main from './Main';
import StepTwo from './StepTwo';
import Results from './Results';
import Welcome from './Welcome';
import DoneMain from './DoneMain';

import { firstUserKey } from './Main';

import { secondUserKey } from './StepTwo';

import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';

import {card} from './card';












class App extends Component {

  


  render() {
    return (
      <Router>
      <div className="App">
        <nav className="navbar navbar-expand-md navbar-dark fixed-top ">
      <a href="/" className="navbar-brand"><i className="fa fa-heartbeat" aria-hidden="true"></i> Pairful</a>
      
      <div className="collapse navbar-collapse" id="navbarCollapse">
          
        
      </div>
    </nav>

    <Route exact path="/" component={Welcome}/>
    <Route path="/main" component={Main}/>
    

      <Route path="/stepTwo/:firstUserKey" component={StepTwo}/>
      <Route path="/results/:secondUserKey" component={Results}/>
      <Route path="/donemain/:firstUserKey" component={DoneMain}/>
    
    
      </div>
      </Router>
    );
  }
}




export default App;



// WEBPACK FOOTER //
// ./src/App.js